module.exports = __webpack_public_path__ + "img/btn-night-mode.bc3006ed.svg";